<template>
  <div id="app">
    <router-view v-wechat-title="$route.meta.title"/>
  </div>
</template>

<script>
export default {
  name: 'App',
  created(){
//    this.$cookies.set('LoginToken','610c678d-0bc6-4528-9d37-0f03c936afd5');
//    this.$cookies.set('UserID','66168')
  }
}
</script>

<style lang="scss" >
  @import "./src/assets/scss/common/base";
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  /*text-align: center;*/
  color: #2c3e50;
/*  margin-top: 60px;*/
}
</style>



// WEBPACK FOOTER //
// src/App.vue